import { render, staticRenderFns } from "./LandingPagesBrandView.vue?vue&type=template&id=0f7e2ee5&scoped=true"
import script from "./LandingPagesBrandView.vue?vue&type=script&lang=js"
export * from "./LandingPagesBrandView.vue?vue&type=script&lang=js"
import style0 from "./LandingPagesBrandView.vue?vue&type=style&index=0&id=0f7e2ee5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7e2ee5",
  null
  
)

export default component.exports